// Modules
import ExtendableError from 'es6-error';

// Types

// Base class
export class URLProviderError extends ExtendableError {
  constructor(...[message, details]) {
    super(message);
    this.details = void 0;
    this.details = details || null;
  }
}

/**
 * DataError
 * The client was not able to retrieve the necessary data to make the request to the media service.
 */
export class DataError extends URLProviderError {}
export class NoURLForMediaServiceError extends DataError {
  constructor(...args) {
    super(...args);
    this.code = 'MS0000';
  }
}
export class NoLicenseTokenError extends DataError {
  constructor(...args) {
    super(...args);
    this.code = 'MS0001';
  }
}
export class NoTrackTokenError extends DataError {
  constructor(...args) {
    super(...args);
    this.code = 'MS0002';
  }
}
export class NoFormatRequestedError extends DataError {
  constructor(...args) {
    super(...args);
    this.code = 'MS0003';
  }
}

/**
 * NetworkError
 * The client was not able to perform the network request to call the media service.
 */

export class NetworkError extends URLProviderError {}
export class NoNetworkError extends NetworkError {
  constructor(...args) {
    super(...args);
    this.code = 'MS0600';
  }
}
export class TimeoutError extends NetworkError {
  constructor(...args) {
    super(...args);
    this.code = 'MS0610';
  }
}

/**
 * ServerError
 * The client received an error from the media service (HTTP status ≥ 500).
 */

export class ServerError extends URLProviderError {
  constructor(...args) {
    super(...args);
    this.code = void 0;
  }
}

/**
 * ParsingError
 * The client was not able to read the response from the media service.
 */

export class ParsingError extends URLProviderError {
  constructor(...args) {
    super(...args);
    this.code = 'MS0674';
  }
}

/**
 * ResponseError
 * The client was able to read and parse the response from the media service but it contains a global error preventing to continue.
 */

export class ResponseError extends URLProviderError {
  get code() {
    return typeof this.details.code !== 'undefined' ? `MS${this.details.code}` : undefined;
  }
}
export class APIDeprecatedError extends ResponseError {}
export class ExpiredLicenseTokenError extends ResponseError {}
export class InvalidLicenseTokenError extends ResponseError {}
export class UnauthorizedLicenseTokenError extends ResponseError {}
export class UnknownCodeError extends ResponseError {}

/**
 * InvalidResponseError
 * The client received a response with no global error but still cannot use it.
 */

export class InvalidResponseError extends URLProviderError {
  constructor(...args) {
    super(...args);
    this.code = 'MS0674';
  }
}

/**
 * MediaError
 * The client received a satisfying response but still cannot use the media to launch the playback.
 */

export class MediaError extends URLProviderError {
  constructor(...args) {
    super(...args);
    this._code = void 0;
  }
  get code() {
    var _this$_code;
    return (_this$_code = this._code) != null ? _this$_code : 'code' in this.details && typeof this.details.code !== 'undefined' ? `MS${this.details.code}` : undefined;
  }
}
export class ExpiredTrackTokenError extends MediaError {}
export class InvalidTrackTokenError extends MediaError {}
export class UnauthorizedTrackTokenError extends MediaError {}
export class UnknownMediaError extends MediaError {}
export class NoFormatError extends MediaError {
  constructor(...args) {
    super(...args);
    this._code = 'MS3000';
  }
}
export class ExpiredURLError extends MediaError {
  constructor(...args) {
    super(...args);
    this._code = 'MS3001';
  }
}
export class EmptySourceError extends MediaError {
  constructor(...args) {
    super(...args);
    this._code = 'MS3002';
  }
}
export class NoMediaResponseError extends MediaError {}
//# sourceMappingURL=DeezerMediaURLProviderErrors.js.map